module.exports = __webpack_public_path__ + "img/offer2.38a7929a.png";